import React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormTextField } from "ui/Form";

import useFormValidator from "hooks/useFormValidator";

import {
  READ_SERVER_SETTINGS_QUERY,
  UPDATE_SMTP_SETTINGS,
} from "graphqlQueries/system";

import {
  SMTP_FROM_ADDR_TITTLE,
  SMTP_LOGIN_TITTLE,
  SMTP_PASSWORD_TITTLE,
  SMTP_PORT_TITTLE,
  SMTP_SERVER_TITTLE,
  SMTP_TO_ADDR_TITTLE,
} from "constants/repoSettings";
import {
  SMTP_FROM_ADDRESS,
  SMTP_LOGIN,
  SMTP_PASSWORD,
  SMTP_PORT,
  SMTP_SERVER,
  SMTP_TO_ADDRESS,
} from "constants/mutationArgs/system";

const fieldsWithPlaceForError = [
  SMTP_SERVER,
  SMTP_PORT,
  SMTP_FROM_ADDRESS,
  SMTP_TO_ADDRESS,
  SMTP_LOGIN,
  SMTP_PASSWORD,
];

const UpdateSmtpSettingsDialog = (props) => {
  const { smtpInfo } = props;

  const initialValues = {
    [SMTP_SERVER]: smtpInfo.smtp_server,
    [SMTP_PORT]: smtpInfo.smtp_port,
    [SMTP_FROM_ADDRESS]: smtpInfo.from_addr,
    [SMTP_TO_ADDRESS]: smtpInfo.to_addr,
    [SMTP_LOGIN]: smtpInfo.smtp_login,
    [SMTP_PASSWORD]: "",
  };

  const { validationSchema } = useFormValidator("update_smtp_settings", {
    [SMTP_SERVER]: SMTP_SERVER_TITTLE,
    [SMTP_PORT]: SMTP_PORT_TITTLE,
    [SMTP_FROM_ADDRESS]: SMTP_FROM_ADDR_TITTLE,
    [SMTP_TO_ADDRESS]: SMTP_TO_ADDR_TITTLE,
    [SMTP_LOGIN]: SMTP_LOGIN_TITTLE,
    [SMTP_PASSWORD]: SMTP_PASSWORD_TITTLE,
  });

  const dataMapper = (data) => {
    const data_ = JSON.parse(JSON.stringify(data));
    data_[SMTP_PASSWORD] === "" && delete data_[SMTP_PASSWORD];
    if (data_[SMTP_PORT]) {
      data_[SMTP_PORT] = Number(data_[SMTP_PORT]);
    }
    return data_;
  };

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_SMTP_SETTINGS}
      refetchQueries={[READ_SERVER_SETTINGS_QUERY]}
      initialValues={initialValues}
      dataMapper={dataMapper}
      validationSchema={validationSchema}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Edit SMTP"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="SMTP information" />
      <FormTextField name={SMTP_SERVER} label={SMTP_SERVER_TITTLE} />
      <FormTextField name={SMTP_PORT} label={SMTP_PORT_TITTLE} />
      <FormTextField name={SMTP_FROM_ADDRESS} label={SMTP_FROM_ADDR_TITTLE} />
      <FormTextField name={SMTP_TO_ADDRESS} label={SMTP_TO_ADDR_TITTLE} />
      <FormTextField name={SMTP_LOGIN} label={SMTP_LOGIN_TITTLE} />
      <FormTextField
        name={SMTP_PASSWORD}
        label={SMTP_PASSWORD_TITTLE}
        type="password"
      />
    </DialogFormWithMutation>
  );
};

UpdateSmtpSettingsDialog.propTypes = {
  smtpInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateSmtpSettingsDialog;
